//#Global Imports
import React from "react";
//#end Global Imports

//#Local Imports
import { CircleXCloseMark, RefreshIcon, SearchIcon } from "../../assets/Icons";
import Button from "../../components/ui/Button";
import TextField from "../../components/ui/TextField";
import Typograpy from "../../components/ui/Typography";
import { IRemitterProps } from "./Remmiter";
import RemitterIconNew from "../../assets/Icons/RemitterIconNew";
import RotateIcon from "../../assets/Icons/Rotate";
//#end Local Imports

const RemitterNavbar: React.FC<IRemitterProps.INavbarProps> = ({
  setAddRemitterModal,
  setSearchedInput,
  searchedInput,
  handleRefresh,
}) => {
  return (
    <div className="p-3 z-40 bg-white/70 backdrop-blur-sm">
      <div className="flex items-center gap-3 w-full">
        {/* <RemitterIconNew /> */}
        <Typograpy tagType="div" text="Remitter" className="text-[30px] font-semibold font-ssp" />
        <div className="w-[657px] mr-20">
          <TextField
            name="searchValue"
            type="text"
            placeholder={
              searchedInput ? (
                <div className="flex items-center w-full justify-between">
                  <div className=" cursor-pointer" onClick={() => {
                    setSearchedInput("")
                  }}>
                    <CircleXCloseMark />
                  </div>
                </div>
              ) : (
                <div className="flex items-center gap-2 w-full">
                  <SearchIcon fillColor="fill-grey-1550" />
                  <span>Search by Name/Number/Email</span>
                </div>
              )
            }
            value={searchedInput}
            fullWidth
            inputClasses="bg-white-200 !border-none !rounded-[145px] !pt-[0rem]"
            placeholderStyle={searchedInput ? "!top-[0.55rem] !left-[79%] text-grey-1550 font-normal text-sm" : "text-grey-1550 font-normal text-sm !right-1/4 w-[90%] !top-[0.55rem]"}
            onChange={(e) => {
              setSearchedInput(e.target.value);
            }}
            pattern="[a-zA-Z0-9 ]{1,}"
            containerStyle="!h-10"
          />
        </div>
        <div className="flex items-center gap-8">
          <Button
            bgColor="bg-transparent"
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-base",
              fontWeight: "font-semibold",
              fontColor: "text-black",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            className="add-remitter-button items-end space-x-4 justify-end"
            onClickHandler={handleRefresh}
          >
            {/* <RefreshIcon fillColor="blue" width={"40px"} height="40px" /> */}
            <RotateIcon />
            {/* <span className="">Refresh</span> */}
          </Button>
           <div className="">
            <Button
              bgColor="bg-[#006EFF]"
              fontStyle={{
                fontFamily: "font-Inter",
                fontSize: "text-sm",
                fontWeight: "font-semibold",
                fontColor: "text-white",
              }}
              borderStyle={{
                borderRadius: "rounded-lg",
              }}
              className="w-22 add-remitter-button p-2"
              onClickHandler={() => {
                setAddRemitterModal(true);
              }}
            >
              ADD NEW REMITTER
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemitterNavbar;
